import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import {Observable} from 'rxjs';

import {AuthenticationService} from "@shared/services/authentication/authentication.service";
import {NewNavigationService} from "@shared/services/new-navigation.service";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(
    private newNavigationService: NewNavigationService,
    private authenticationService: AuthenticationService
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return new Observable<boolean>(observer => {
      const result = this.authenticationService.isSessionActive;
        observer.next(result);
        observer.complete();
    });
  }

}
